import { isClientSide } from "@helper/utils";
import { useEffect, useRef, useState } from "react";

type UseHeaderScrollReturn = {
  showMosqueBtn: boolean;
  isDesktopScrolled: boolean;
};

export function useHeaderScroll(
  compactMobileHeader?: boolean,
  setLayoutHeights?: () => void,
): UseHeaderScrollReturn {
  const [showMosqueBtn, setShowMosqueBtn] = useState(false);
  const [isDesktopScrolled, setIsDesktopScrolled] = useState(false);
  const rafId = useRef<number | null>(null);

  useEffect(() => {
    if (!isClientSide) return;

    const handleScroll = () => {
      const scrollY = window.scrollY;

      // Mobile
      setShowMosqueBtn(compactMobileHeader || scrollY > 100);

      // Desktop with hysteresis
      setIsDesktopScrolled((prev) => {
        if (!prev && scrollY > 300) return true; // enter
        if (prev && scrollY < 200) return false; // exit
        return prev;
      });

      // Dedupe layout measurements within a single frame
      if (setLayoutHeights) {
        if (rafId.current !== null) cancelAnimationFrame(rafId.current);
        rafId.current = requestAnimationFrame(() => {
          rafId.current = null;
          setLayoutHeights();
        });
      }
    };

    handleScroll(); // Check initial position
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (rafId.current !== null) cancelAnimationFrame(rafId.current);
    };
  }, [compactMobileHeader, setLayoutHeights]);

  return {
    showMosqueBtn,
    isDesktopScrolled,
  };
}
